/* Decottaa teması – dikey video hikâyeler. */
(() => {
  const theme = window.theme || {};
  if (!theme.utils) return;
  const { $, $$, debounce, reducedMotion } = theme.utils;

  /* ---------- Video hikâyeler ---------- */
  class VideoStories extends HTMLElement {
    connectedCallback() {
      this.track = $('[data-stories-track]', this);
      this.viewer = $('[data-story-viewer]', this);
      if (!this.track) return;
      this.prev = $('[data-stories-prev]', this);
      this.next = $('[data-stories-next]', this);
      this.prev?.addEventListener('click', () => this.advance(-1));
      this.next?.addEventListener('click', () => this.advance(1));
      this.onScroll = debounce(() => this.refreshNav(), 100);
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll);
      this.refreshNav();

      if ('IntersectionObserver' in window && !reducedMotion.matches) {
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach(({ target, isIntersecting }) => {
              if (isIntersecting) target.play().catch(() => {});
              else target.pause();
            });
          },
          { root: this.track, rootMargin: '90px', threshold: 0.35 }
        );
        $$('video.story-video', this.track).forEach((video) => this.observer.observe(video));
      }

      this.track.addEventListener('click', (event) => {
        const button = event.target.closest('[data-story-open]');
        if (button) this.openStory(button);
      });
      if (this.viewer) {
        this.viewer.addEventListener('click', (event) => {
          if (event.target === this.viewer || event.target.closest('[data-story-close]')) this.viewer.close();
        });
        this.viewer.addEventListener('close', () => {
          const video = $('[data-story-video]', this.viewer);
          video.pause();
          video.replaceChildren();
          video.removeAttribute('src');
          video.load();
          this.lastFocus?.focus();
          // Kartlar yeniden gözlenir: ekranda görünenler kaldığı yerden sessiz oynamaya devam eder
          if (this.observer) {
            $$('video.story-video', this.track).forEach((card) => {
              this.observer.unobserve(card);
              this.observer.observe(card);
            });
          }
        });
      }
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      window.removeEventListener('resize', this.onScroll);
    }

    advance(direction) {
      const card = $('.story-card', this.track);
      if (!card) return;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 18;
      this.track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: reducedMotion.matches ? 'auto' : 'smooth' });
    }

    refreshNav() {
      if (this.prev) this.prev.disabled = this.track.scrollLeft < 4;
      if (this.next) this.next.disabled = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 4;
    }

    openStory(button) {
      // Kartta video olmayabilir (varsayılan: yalnız kapak görseli); adres düğmedeki data-video-src'de
      const source = $('video', button);
      const src = button.dataset.videoSrc || (source && source.dataset.fullSrc);
      if (!this.viewer || (!src && !source)) {
        if (button.dataset.storyUrl) window.location.href = button.dataset.storyUrl;
        return;
      }
      this.lastFocus = button;
      $$('video.story-video', this.track).forEach((video) => video.pause());
      const video = $('[data-story-video]', this.viewer);
      if (src) {
        video.replaceChildren();
        video.src = src;
      } else {
        video.removeAttribute('src');
        video.replaceChildren(...$$('source', source).map((node) => node.cloneNode(true)));
      }
      const poster = button.dataset.videoPoster || (source && source.poster);
      if (poster) video.poster = poster;
      else video.removeAttribute('poster');
      $('[data-story-title]', this.viewer).textContent = button.dataset.storyTitle || '';
      const link = $('[data-story-link]', this.viewer);
      if (button.dataset.storyUrl) {
        link.href = button.dataset.storyUrl;
        link.hidden = false;
      } else {
        link.hidden = true;
      }
      this.viewer.showModal();
      video.load();
      video.play().catch(() => {});
    }
  }
  if (!customElements.get('video-stories')) customElements.define('video-stories', VideoStories);


  document.addEventListener('shopify:block:select', (event) => {
    const story = event.target.closest('.story-card');
    story?.scrollIntoView({ block: 'nearest', inline: 'start' });
  });
})();
